import * as CryptoJS from 'crypto-js';
import { axios } from '../utils/axios';
import { call } from 'redux-saga/effects';
import { AxiosRequestConfig } from 'axios';
import parse from 'url-parse';

const {
  enc: { Base64, Utf8 },
  HmacSHA256,
} = CryptoJS;

const REACT_APP_API_AUTH_SECRET_KEY = process.env.REACT_APP_API_AUTH_SECRET_KEY;
if (!REACT_APP_API_AUTH_SECRET_KEY) {
  throw new Error('Could not resolve REACT_APP_API_AUTH_SECRET_KEY from env vars');
}

const REACT_APP_API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
if (!REACT_APP_API_ENDPOINT) {
  throw new Error('Could not resolve REACT_APP_API_ENDPOINT from env vars');
}

const getAuthHeaders = (message: string, secretKey: string = REACT_APP_API_AUTH_SECRET_KEY) => {
  const timestamp = Math.floor(Date.now() / 1000);
  const messageUTF8 = Utf8.parse(message);
  const timestampedMessage = timestamp + Base64.stringify(messageUTF8);
  const hash = HmacSHA256(timestampedMessage, secretKey);

  return {
    ACCEPT: 'application/vnd.api+json',
    TIMESTAMP: timestamp,
    AUTHORISATION: hash,
    'Content-Type': 'application/vnd.api+json',
  };
};

export const query = (
  config: AxiosRequestConfig,
  apiEndpoint: string = REACT_APP_API_ENDPOINT,
  secretKey: string = REACT_APP_API_AUTH_SECRET_KEY
) => {
  const { url, method, data } = config;
  const urlPath = url ? parse(url).pathname : '';
  const message = method === 'post' || method === 'patch' ? JSON.stringify(data) : urlPath;

  return axios.request({
    ...config,
    headers: {
      ...getAuthHeaders(message || '', secretKey),
    },
    url: `${apiEndpoint}${url}`,
  });
};

export function* queryData(config: AxiosRequestConfig) {
  const { data } = yield call(query, config);
  return data;
}
